// extracted by mini-css-extract-plugin
export default {"switch":"darkStyle_switch__dEGo0","checked":"darkStyle_checked__HoI7D","disabled":"darkStyle_disabled__Phncv","input":"darkStyle_input__llqGE"};